var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100.5C40.8854 100.37 32.5521 98.1562 25 93.8594C17.4479 89.4323 11.3281 83.3125 6.64062 75.5C2.21354 67.5573 0 59.224 0 50.5C0 41.776 2.21354 33.4427 6.64062 25.5C11.3281 17.6875 17.4479 11.5677 25 7.14062C32.5521 2.84375 40.8854 0.630208 50 0.5C59.1146 0.630208 67.4479 2.84375 75 7.14062C82.5521 11.5677 88.6719 17.6875 93.3594 25.5C97.7865 33.4427 100 41.776 100 50.5C100 59.224 97.7865 67.5573 93.3594 75.5C88.6719 83.3125 82.5521 89.4323 75 93.8594C67.4479 98.1562 59.1146 100.37 50 100.5ZM72.0703 41.3203C73.8932 39.1068 73.8932 36.8932 72.0703 34.6797C69.8568 32.8568 67.6432 32.8568 65.4297 34.6797L43.75 56.3594L34.5703 47.1797C32.3568 45.3568 30.1432 45.3568 27.9297 47.1797C26.1068 49.3932 26.1068 51.6068 27.9297 53.8203L40.4297 66.3203C42.6432 68.1432 44.8568 68.1432 47.0703 66.3203L72.0703 41.3203L47.0703 66.3203L72.0703 41.3203Z",
    fill: "#00AC69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessStatusIcon);
export default __webpack_public_path__ + "static/media/successStatusIcon.228595e244a97af2d0ef524bc6803341.svg";
export { ForwardRef as ReactComponent };